var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 15,
    r: 15,
    cx: 40,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.8,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 15,
    r: 15,
    cx: 100,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.8,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 15,
    r: 15,
    cx: 160,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.8,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5657bfbaf456a0567d4aa45dbb572abc.svg";
export { ForwardRef as ReactComponent };